import React from "react";
import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemIcon, ListItemText, MenuItem, Select, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import InfoIcon from '@mui/icons-material/Info';
import PropTypes from 'prop-types';

const MenuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

export default function MultiSelectInput(props) {

    const { errors, selectOptions, id, variant, helpText, inputColumnSize, value, ...textFieldProps } = props;
    const selectedValue = Array.isArray(value) ? value : value.split(",").map(item => item.trim());
    const columnSize = inputColumnSize || 12;

    const menuItems = selectOptions && selectOptions.map((option, key) => {
        return <MenuItem className="p-0" key={key + 1} value={option.value} disabled={option.disabled}>
            <ListItemIcon className="me-n3">
                <Checkbox className="py-1" checked={selectedValue.indexOf(option.value) > -1} color="primary" />
            </ListItemIcon>
            <ListItemText className="me-3" primary={option.label} />
        </MenuItem>
    });

    return (
        <Row>
            <Col xs={columnSize}>
                <FormControl fullWidth variant='outlined' error={!!errors}>
                    <InputLabel htmlFor={id}>{props.label}</InputLabel>
                    <Select
                        multiple
                        value={selectedValue}
                        renderValue={() => selectedValue.join(', ')}
                        MenuProps={MenuProps}
                        inputProps={{ id: id }}
                        {...textFieldProps}
                        fullWidth
                    >
                        {menuItems}
                    </Select>
                    <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
                </FormControl>
            </Col>

            {helpText &&
                <Col xs={2}>
                    <div className="d-flex mt-2">
                        <Tooltip title={helpText}>
                            <InfoIcon color="primary"></InfoIcon>
                        </Tooltip>
                    </div>
                </Col>
            }
        </Row>
    );
}

MultiSelectInput.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selectOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    variant: PropTypes.string,
    errors: PropTypes.object,
    helpText: PropTypes.string
}
